/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Activation_Code_PlaceholderInputs */

const en_offline_activation_code_placeholder = /** @type {(inputs: Offline_Activation_Code_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activation Code`)
};

const fr_offline_activation_code_placeholder = /** @type {(inputs: Offline_Activation_Code_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Code d'activation`)
};

const de_offline_activation_code_placeholder = /** @type {(inputs: Offline_Activation_Code_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktivierungscode`)
};

const it_offline_activation_code_placeholder = /** @type {(inputs: Offline_Activation_Code_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codice di attivazione`)
};

const ru_offline_activation_code_placeholder = /** @type {(inputs: Offline_Activation_Code_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Код активации`)
};

const es_offline_activation_code_placeholder = /** @type {(inputs: Offline_Activation_Code_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Código de activación`)
};

const zh_cn2_offline_activation_code_placeholder = /** @type {(inputs: Offline_Activation_Code_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`激活码`)
};

const ja_offline_activation_code_placeholder = /** @type {(inputs: Offline_Activation_Code_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アクティベーションコード`)
};

const hi_offline_activation_code_placeholder = /** @type {(inputs: Offline_Activation_Code_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एक्टिवेशन कोड`)
};

const pt_pt2_offline_activation_code_placeholder = /** @type {(inputs: Offline_Activation_Code_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Código de ativação`)
};

/**
* | output |
* | --- |
* | "Activation Code" |
*
* @param {Offline_Activation_Code_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const offline_activation_code_placeholder = /** @type {((inputs?: Offline_Activation_Code_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Activation_Code_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_offline_activation_code_placeholder(inputs)
	if (locale === "de") return de_offline_activation_code_placeholder(inputs)
	if (locale === "it") return it_offline_activation_code_placeholder(inputs)
	if (locale === "ru") return ru_offline_activation_code_placeholder(inputs)
	if (locale === "es") return es_offline_activation_code_placeholder(inputs)
	if (locale === "zh-CN") return zh_cn2_offline_activation_code_placeholder(inputs)
	if (locale === "ja") return ja_offline_activation_code_placeholder(inputs)
	if (locale === "hi") return hi_offline_activation_code_placeholder(inputs)
	if (locale === "pt-PT") return pt_pt2_offline_activation_code_placeholder(inputs)
	return en_offline_activation_code_placeholder(inputs)
});